<template>
  <div class="kg-collapse">
    <template v-if="menuData && menuData.length">
      <div class="kg-collapse-scroll">
        <div v-for="item in menuData" :key="item.id">
          <div
            class="kg-collapse-item"
            :class="{ active: menuActiveBus[0] && menuActiveBus[0].id == item.id }"
            @click="handleChapter(item)"
          >
            <span class="kg-collapse-item-text">{{ item.name }}</span>
            <i
              v-if="getChildren(item) && getChildren(item).length"
              class="el-icon-arrow-right kg-collapse-arrow"
              :class="{ 'is-open': menuActiveBus[0] && menuActiveBus[0].id == item.id }"
            ></i>
          </div>
          <div
            v-if="menuActiveBus[0] && menuActiveBus[0].id == item.id && getChildren(item) && getChildren(item).length"
            class="kg-collapse-sub"
          >
            <div
              v-for="node in getChildren(item)"
              :key="node.id"
              class="kg-collapse-sub-item"
              :class="{ active: menuActiveBus[1] && menuActiveBus[1].id == node.id }"
              @click="handleNode(node)"
            >
              {{ node.name }}
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'KgCollapse',
  inject: ['menuActiveBus', 'btnActiveBus', 'getknowledgeData'],
  props: {
    menuData: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getChildren(item) {
      // 兼容 children（hpk后端）和 chapters（educationblend后端）两种字段名
      return item.children || item.chapters || []
    },
    handleChapter(item) {
      this.btnActiveBus.value = null
      var { id, name } = item
      if (this.menuActiveBus.length === 1 && this.menuActiveBus[0].id === id) {
        this.menuActiveBus.splice(0, this.menuActiveBus.length)
      } else {
        this.menuActiveBus.splice(0, this.menuActiveBus.length, { id, name })
      }
      this.getknowledgeData()
    },
    handleNode(item) {
      this.btnActiveBus.value = null
      var { id, name } = item
      if (this.menuActiveBus.length === 2 && this.menuActiveBus[1].id === id) {
        this.menuActiveBus.splice(1, 1)
      } else {
        this.menuActiveBus.splice(1, 1, { id, name })
      }
      this.getknowledgeData()
    },
  },
}
</script>

<style scoped lang="less">
.kg-collapse {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.kg-collapse-scroll {
  height: 100%;
  overflow-y: auto;
}
.kg-collapse-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  font-size: 14px;
  padding: 10px 10px;
  border-bottom: 1px solid #eee;
  &.active {
    color: #3e8fff;
  }
  &:hover {
    color: #3e8fff;
  }
}
.kg-collapse-item-text {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.kg-collapse-arrow {
  transition: transform 0.3s;
  &.is-open {
    transform: rotate(90deg);
  }
}
.kg-collapse-sub {
  background: #f8faff;
}
.kg-collapse-sub-item {
  padding: 10px 15px;
  font-size: 14px;
  cursor: pointer;
  &.active {
    color: #3e8fff;
  }
  &:hover {
    color: #3e8fff;
  }
}
</style>
